import {Component, computed, inject} from '@angular/core';
import {DatePipe} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';
import {Title} from '../../../../components/title/title';
import {CurrentUserService} from '../../../../services/current-user.service';
import {DashboardInvoicingChart} from '../dashboard-invoicing-chart/dashboard-invoicing-chart';
import {DashboardProductHistory} from '../dashboard-product-history/dashboard-product-history';
import {DashboardTimeBreakdown} from '../dashboard-time-breakdown/dashboard-time-breakdown';
import {DashboardTimeChart} from '../dashboard-time-chart/dashboard-time-chart';
import {DashboardTimeTile} from '../dashboard-time-tile/dashboard-time-tile';
import {DashboardUrgentTodos} from '../dashboard-urgent-todos/dashboard-urgent-todos';

@Component({
  selector: 'elcia-dashboard',
  imports: [
    DatePipe,
    Title,
    TranslatePipe,
    DashboardInvoicingChart,
    DashboardProductHistory,
    DashboardTimeBreakdown,
    DashboardTimeChart,
    DashboardTimeTile,
    DashboardUrgentTodos,
  ],
  templateUrl: './dashboard-home.component.html',
  styleUrl: './dashboard-home.component.scss',
})
export class DashboardSummary {

  protected readonly currentUserService = inject(CurrentUserService);
  private readonly currentUser = this.currentUserService.currentUser;

  protected readonly greetingParams = computed(() => ({'0': this.currentUser()?.firstName ?? ''}));

  // Every figure on this page is scoped to the current month: the header states which one, otherwise
  // "42h30 +12%" says nothing about what it covers.
  protected readonly referenceMonth = new Date();
}
